import { render, staticRenderFns } from "./serverdialog.vue?vue&type=template&id=4ce2668e"
import script from "./serverdialog.vue?vue&type=script&lang=js"
export * from "./serverdialog.vue?vue&type=script&lang=js"
import style0 from "./serverdialog.vue?vue&type=style&index=0&id=4ce2668e&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports